<script>
export default {
  inheritAttrs: false,
  props: {
    loginMethodInitial: {
      required: true,
      type: String
    },
    newsletterFlagInitial: {
      required: true,
      type: Boolean
    }
  },

  render() {
    return this.$slots.default({
      loginMethod: this.loginMethod,
      updateLoginMethod: this.updateLoginMethod,
      newsletterFlag: this.newsletterFlag,
      updateNewsletterFlag: this.updateNewsletterFlag
    })
  },

  data() {
    return {
      loginMethod: this.loginMethodInitial,
      newsletterFlag: this.newsletterFlagInitial,
    }
  },

  methods: {
    updateLoginMethod(value) {
      this.loginMethod = value;
    },
    updateNewsletterFlag(value) {
      this.newsletterFlag = value;
    },
  }
}
</script>
